var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { connectNodePairs, wireOrgChartConnectors, wireMindMapConnectors } from '../connectors';
import { getActiveDiagram } from '../theme';
import { collectObstacles } from '../router';
import { rewireSchematic } from '../symbols';
import { collectEditableNodes, collectEdgesFromLayer, findEdgeLayer, findNodeByDiagramId, } from './collect';
import { refreshDiagramFlow, stopDiagramFlow } from '../flow';
/** Rebuild all connectors in the diagram edge layer from stored edge metadata. */
export function rerouteDiagramEdges(app, root, edges, opts) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d, e_5, _e;
    var _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    stopDiagramFlow(root);
    var type = (_f = root.metadata) === null || _f === void 0 ? void 0 : _f.diagramType;
    // Keep Mermaid-style wiring for org / mind maps (mindmap stays curved branches)
    if (type === 'orgChart') {
        wireOrgChartConnectors(app, root);
        root.markDirty();
        refreshDiagramFlow(app, root);
        return;
    }
    if (type === 'mindMap') {
        try {
            for (var _3 = __values(__spreadArray([], __read(root.children), false)), _4 = _3.next(); !_4.done; _4 = _3.next()) {
                var child = _4.value;
                if ((_g = child.metadata) === null || _g === void 0 ? void 0 : _g.diagramEdgeLayer) {
                    root.remove(child);
                    child.destroy();
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_4 && !_4.done && (_a = _3.return)) _a.call(_3);
            }
            finally { if (e_1) throw e_1.error; }
        }
        wireMindMapConnectors(app, root);
        root.markDirty();
        refreshDiagramFlow(app, root);
        return;
    }
    if (type === 'electricalSchematic') {
        rewireSchematic(app, root);
        refreshDiagramFlow(app, root);
        return;
    }
    if (type === 'canNetwork') {
        // applyDiagramFlow rebuilds bus-rail hop edges from current ECU positions
        root.markDirty();
        refreshDiagramFlow(app, root);
        return;
    }
    var edgeLayer = findEdgeLayer(root);
    if (!edgeLayer)
        return;
    var clearIds = new Set((_h = opts === null || opts === void 0 ? void 0 : opts.clearWaypointsForNodes) !== null && _h !== void 0 ? _h : []);
    if (clearIds.size > 0) {
        try {
            for (var clearIds_1 = __values(clearIds), clearIds_1_1 = clearIds_1.next(); !clearIds_1_1.done; clearIds_1_1 = clearIds_1.next()) {
                var id = clearIds_1_1.value;
                clearEdgeWaypointsForNode(root, id);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (clearIds_1_1 && !clearIds_1_1.done && (_b = clearIds_1.return)) _b.call(clearIds_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    var records = (edges !== null && edges !== void 0 ? edges : collectEdgesFromLayer(edgeLayer)).map(function (edge) {
        var touchesCleared = (opts === null || opts === void 0 ? void 0 : opts.forgetAllWaypoints) ||
            clearIds.has(edge.from) ||
            clearIds.has(edge.to);
        if (!touchesCleared)
            return edge;
        return __assign(__assign({}, edge), { waypoints: undefined, options: edge.options
                ? __assign(__assign({}, edge.options), { waypoints: undefined }) : edge.options });
    });
    var nodeMap = new Map(collectEditableNodes(root).map(function (n) { return [n.metadata.diagramId, n]; }));
    try {
        for (var _5 = __values(__spreadArray([], __read(edgeLayer.children), false)), _6 = _5.next(); !_6.done; _6 = _5.next()) {
            var child = _6.value;
            edgeLayer.remove(child);
            child.destroy();
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_6 && !_6.done && (_c = _5.return)) _c.call(_5);
        }
        finally { if (e_3) throw e_3.error; }
    }
    var obstacles = collectObstacles(__spreadArray([], __read(nodeMap.values()), false));
    var allNodes = __spreadArray([], __read(nodeMap.values()), false);
    var pairs = [];
    try {
        for (var records_1 = __values(records), records_1_1 = records_1.next(); !records_1_1.done; records_1_1 = records_1.next()) {
            var edge = records_1_1.value;
            var from = (_j = findNodeByDiagramId(root, edge.from)) !== null && _j !== void 0 ? _j : nodeMap.get(edge.from);
            var to = (_k = findNodeByDiagramId(root, edge.to)) !== null && _k !== void 0 ? _k : nodeMap.get(edge.to);
            if (!from || !to)
                continue;
            var waypoints = (opts === null || opts === void 0 ? void 0 : opts.forgetAllWaypoints)
                ? undefined
                : (_l = edge.waypoints) !== null && _l !== void 0 ? _l : (_m = edge.options) === null || _m === void 0 ? void 0 : _m.waypoints;
            pairs.push({
                from: from,
                to: to,
                options: {
                    stroke: (_p = (_o = edge.options) === null || _o === void 0 ? void 0 : _o.stroke) !== null && _p !== void 0 ? _p : getActiveDiagram().edge,
                    glowColor: (_r = (_q = edge.options) === null || _q === void 0 ? void 0 : _q.glowColor) !== null && _r !== void 0 ? _r : getActiveDiagram().edgeGlow,
                    strokeWidth: (_t = (_s = edge.options) === null || _s === void 0 ? void 0 : _s.strokeWidth) !== null && _t !== void 0 ? _t : getActiveDiagram().stroke.edge,
                    label: edge.label,
                    style: (_v = (_u = edge.options) === null || _u === void 0 ? void 0 : _u.style) !== null && _v !== void 0 ? _v : 'smart',
                    arrowEnd: (_x = (_w = edge.options) === null || _w === void 0 ? void 0 : _w.arrowEnd) !== null && _x !== void 0 ? _x : 'filled',
                    arrowStart: (_z = (_y = edge.options) === null || _y === void 0 ? void 0 : _y.arrowStart) !== null && _z !== void 0 ? _z : 'none',
                    dash: (_0 = edge.options) === null || _0 === void 0 ? void 0 : _0.dash,
                    cornerRadius: (_2 = (_1 = edge.options) === null || _1 === void 0 ? void 0 : _1.cornerRadius) !== null && _2 !== void 0 ? _2 : 10,
                    waypoints: waypoints,
                    edgeId: edge.id,
                    fromId: edge.from,
                    toId: edge.to,
                },
            });
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (records_1_1 && !records_1_1.done && (_d = records_1.return)) _d.call(records_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    var wired = connectNodePairs(app, pairs, {
        parent: root,
        obstacleNodes: allNodes,
        obstacles: obstacles,
        style: 'smart',
        glow: false,
    });
    try {
        for (var wired_1 = __values(wired), wired_1_1 = wired_1.next(); !wired_1_1.done; wired_1_1 = wired_1.next()) {
            var g = wired_1_1.value;
            edgeLayer.add(g);
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (wired_1_1 && !wired_1_1.done && (_e = wired_1.return)) _e.call(wired_1);
        }
        finally { if (e_5) throw e_5.error; }
    }
    root.markDirty();
    refreshDiagramFlow(app, root);
}
/**
 * Drop manual bend points on edges touching `nodeId` so smart routing can
 * rebuild a clean path after rotate/move. Users can add bends again afterward.
 */
export function clearEdgeWaypointsForNode(root, nodeId) {
    var e_6, _a;
    var _b, _c;
    var edgeLayer = findEdgeLayer(root);
    if (!edgeLayer || !nodeId)
        return;
    try {
        for (var _d = __values(edgeLayer.children), _e = _d.next(); !_e.done; _e = _d.next()) {
            var child = _e.value;
            var from = (_b = child.metadata) === null || _b === void 0 ? void 0 : _b.edgeFrom;
            var to = (_c = child.metadata) === null || _c === void 0 ? void 0 : _c.edgeTo;
            if (from !== nodeId && to !== nodeId)
                continue;
            delete child.metadata.edgeWaypoints;
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_6) throw e_6.error; }
    }
}
/** Persist node positions into diagramState for JSON round-trip. */
export function syncPositionsToState(root) {
    var e_7, _a, e_8, _b, e_9, _c, e_10, _d;
    var _e, _f, _g;
    var state = __assign({}, (_e = root.metadata) === null || _e === void 0 ? void 0 : _e.diagramState);
    var type = (_f = root.metadata) === null || _f === void 0 ? void 0 : _f.diagramType;
    var nodes = collectEditableNodes(root);
    var positions = {};
    try {
        for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var n = nodes_1_1.value;
            var id = (_g = n.metadata) === null || _g === void 0 ? void 0 : _g.diagramId;
            if (!id)
                continue;
            positions[id] = {
                x: n.x,
                y: n.y,
                scaleX: n.scaleX,
                scaleY: n.scaleY,
                rotation: n.rotation,
            };
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_7) throw e_7.error; }
    }
    state.editorPositions = positions;
    if (type === 'flowchart' || type === 'networkTopology') {
        var data = state.data;
        if (data === null || data === void 0 ? void 0 : data.nodes) {
            try {
                for (var _h = __values(data.nodes), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var n = _j.value;
                    var p = positions[n.id];
                    if (p) {
                        n.x = p.x;
                        n.y = p.y;
                        n.rotation = p.rotation;
                    }
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
                }
                finally { if (e_8) throw e_8.error; }
            }
            state.data = data;
        }
    }
    if (type === 'stateMachine') {
        var data = state.data;
        if (data === null || data === void 0 ? void 0 : data.states) {
            try {
                for (var _k = __values(data.states), _l = _k.next(); !_l.done; _l = _k.next()) {
                    var s = _l.value;
                    var p = positions[s.id];
                    if (p) {
                        s.x = p.x;
                        s.y = p.y;
                        s.rotation = p.rotation;
                    }
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                }
                finally { if (e_9) throw e_9.error; }
            }
            state.data = data;
        }
    }
    if (type === 'processPipeline') {
        var stages = state.stages;
        if (stages) {
            state.stages = stages.map(function (s) {
                var p = positions[s.id];
                return p ? __assign(__assign({}, s), { x: p.x, y: p.y, rotation: p.rotation }) : s;
            });
        }
    }
    if (type === 'electricalSchematic') {
        var components = state.components;
        if (components) {
            state.components = components.map(function (c) {
                var p = positions[c.id];
                return p ? __assign(__assign({}, c), { x: p.x, y: p.y, rotation: p.rotation }) : c;
            });
        }
    }
    if (type === 'classDiagram') {
        var data = state.data;
        if (data === null || data === void 0 ? void 0 : data.classes) {
            try {
                for (var _m = __values(data.classes), _o = _m.next(); !_o.done; _o = _m.next()) {
                    var c = _o.value;
                    var p = positions[c.id];
                    if (p) {
                        c.x = p.x;
                        c.y = p.y;
                        c.rotation = p.rotation;
                    }
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
                }
                finally { if (e_10) throw e_10.error; }
            }
            state.data = data;
        }
    }
    root.metadata.diagramState = state;
}
export function syncEdgesToState(root) {
    var _a, _b;
    var edgeLayer = findEdgeLayer(root);
    if (!edgeLayer)
        return;
    var edges = collectEdgesFromLayer(edgeLayer);
    var state = __assign({}, (_a = root.metadata) === null || _a === void 0 ? void 0 : _a.diagramState);
    state.editorEdges = edges;
    var type = (_b = root.metadata) === null || _b === void 0 ? void 0 : _b.diagramType;
    if (type === 'flowchart' || type === 'networkTopology') {
        var data = state.data;
        if (data) {
            data.edges = edges.map(function (e) { return ({ from: e.from, to: e.to, label: e.label }); });
            state.data = data;
        }
    }
    if (type === 'stateMachine') {
        var data = state.data;
        if (data) {
            data.transitions = edges.map(function (e) { return ({ from: e.from, to: e.to, label: e.label }); });
            state.data = data;
        }
    }
    root.metadata.diagramState = state;
}
